var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTape(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 47,
    height: 40,
    viewBox: "0 0 47 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M42.7421 11.04C42.7421 17.1372 33.174 22.08 21.371 22.08C9.56812 22.08 0 17.1372 0 11.04C0 4.9428 9.56812 0 21.371 0C33.174 0 42.7421 4.9428 42.7421 11.04ZM29.5907 11.04C29.5907 13.4259 25.9106 15.36 21.371 15.36C16.8315 15.36 13.1514 13.4259 13.1514 11.04C13.1514 8.65411 16.8315 6.72 21.371 6.72C25.9106 6.72 29.5907 8.65411 29.5907 11.04Z",
    fill: "#D56B4E"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M37.3258 20.5604C36.1152 21.1858 34.7761 21.6123 33.3438 22.0805C36.7231 22.1124 40.1467 22.0586 42.7376 22.0805V16.2695C41.4112 17.9996 39.4895 19.4427 37.3258 20.5604Z",
    fill: "#9D4F39"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M5.41185 20.5604C3.24812 19.4427 1.32646 17.9996 0 16.2695V28.3421C0 31.3443 2.32888 34.0661 6.10601 36.0533V33.6005C6.10601 33.0702 6.52658 32.6405 7.0454 32.6405C7.56422 32.6405 7.98479 33.0702 7.98479 33.6005V36.9317C10.1761 37.8408 12.7226 38.531 15.4999 38.9395V35.0405C15.4999 34.5103 15.9204 34.0805 16.4393 34.0805C16.9581 34.0805 17.3787 34.5103 17.3787 35.0405V39.1685C18.672 39.2947 20.0066 39.3605 21.371 39.3605H25.8331V35.5205C25.8331 34.9902 26.2537 34.5605 26.7725 34.5605C27.2913 34.5605 27.7119 34.9902 27.7119 35.5205V39.3605H36.6361V35.5205C36.6361 34.9902 37.0566 34.5605 37.5755 34.5605C38.0943 34.5605 38.5148 34.9902 38.5148 35.5205V39.3605H44.6213C45.9182 39.3605 46.9693 38.2857 46.9693 36.9605V26.4005C46.9693 25.075 45.9266 23.9993 44.6298 23.9893C36.5635 23.9269 28.4978 23.9748 20.4317 24.0005C15.3366 24.0005 9.96144 22.9107 5.41185 20.5604Z",
    fill: "#9D4F39"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTape);
export default __webpack_public_path__ + "static/media/tape.f336b687ebe2f6caa12c10cd9c08b6f4.svg";
export { ForwardRef as ReactComponent };